import React from 'react';
import { Grid, GridProps, useMediaQuery, withStyles } from '@material-ui/core';
import cn from 'classnames';
import useTheme from '@material-ui/core/styles/useTheme';

interface FsGridContainerProps extends GridProps {
  withMargin?: boolean;
}

export default withStyles(({ spacing, breakpoints }) => ({
  root: {
    marginBottom: spacing(1),
    [breakpoints.up('sm')]: {
      marginBottom: spacing(2),
    },
    '&.noMargin': {
      marginBottom: 0,
      [breakpoints.up('sm')]: {
        marginBottom: 0,
      },
    },
  },
}))(({ withMargin = true, ...props }: FsGridContainerProps) => {
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });

  return (
    <Grid
      container
      direction="row"
      alignItems="stretch"
      spacing={isUpSm ? 3 : 2}
      className={cn({ noMargin: !withMargin })}
      {...props}
    />
  );
});
